import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	multipleFlagsIconLabel: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.icon.multiple-flags-icon-label',
		defaultMessage: 'Multiple feature flags',
		description: 'Label for an icon that indicates there are multiple feature flags.',
	},
});
